import React from 'react';

import './styles.css';

export default class Hero extends React.Component {
  onDownArrowClick = () => {
    this.props.scrollTo('about')
  }

  render() {
    return (
      <div className="Hero ">
        <div className="Hero-content">
          <h1 className="Hero-title">SteinKompaníið</h1>

          <p className="Hero-description">
            Framleiðsla á legsteinum og gólfflísum
            úr íslensku náttúrugrjóti sem og önnur
            sérsmíði og hugmyndavinna
          </p>
          <a onClick={this.onDownArrowClick}><i className="Hero-down-arrow"></i></a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/hero/index.js